import { render, staticRenderFns } from "./k2Textarea.vue?vue&type=template&id=36e6a3f5"
import script from "./k2Textarea.vue?vue&type=script&lang=js"
export * from "./k2Textarea.vue?vue&type=script&lang=js"
import style0 from "./k2Textarea.vue?vue&type=style&index=0&id=36e6a3f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports